import React, { ReactNode } from 'react';
import styled from 'styled-components';
import { Text } from '../Text/Text';
import { COLORS } from '../../constants';

interface DivProps extends React.HTMLProps<HTMLDivElement> {
  text: string;
  parseBy: string;
  textWidth?: number;
  textSize?: number;
  textColor?: string;
  textWeight?: number;
  textElement: ReactNode;
}

export const TextParser: React.FC<DivProps> = ({
  text,
  parseBy,
  textWidth,
  textSize = 20,
  textColor = COLORS.BLACK,
  textWeight = 400,
  textElement,
  children,
  ...props
}) => {
  const featArr = text.split(parseBy);
  const resArr = featArr
    .filter(el => el !== '')
    .map(el => (featArr.length > 1 ? `- ${el}` : el));

  return (
    <ElementStyle {...props}>
      {resArr.map((el: string, index: number) => (
        <TextContainer key={index} $width={360}>
          <Text
            text={el}
            size={textSize}
            weight={textWeight}
            color={textColor}
          />
        </TextContainer>
      ))}
    </ElementStyle>
  );
};

const ElementStyle = styled.div``;

const TextContainer = styled.div<{ $width: number }>`
  max-width: ${props => `${props.$width}px`};
`;
